import type { Dictionary } from "./hy";

export const ru: Dictionary = {
  meta: { code: "ru", label: "Рус", name: "Русский", ogLocale: "ru_RU" },
  common: {
    brand: "Global IT Academy",
    details: "Подробнее",
    learnMore: "Узнать больше",
    registerNow: "Записаться",
    loading: "Загрузка...",
    visit: "Перейти",
    close: "Закрыть",
    add: "Добавить",
  },
  nav: {
    home: "Главная",
    news: "Новости",
    admission: "Поступление",
    services: "Услуги",
    contact: "Контакты",
    login: "Войти",
    logout: "Выйти",
    signOut: "Выйти из системы",
    admin: "Админ",
    lecturer: "Преподаватель",
    student: "Студент",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    language: "Язык",
    theme: "Тема",
    switchToLight: "Включить светлую тему",
    switchToDark: "Включить тёмную тему",
    light: "Светлая",
    dark: "Тёмная",
  },
  hero: {
    badge: "Набор открыт",
    closed: "Набор закрыт",
    until: "до",
    titleLead: "IT-курсы в Армении:",
    titleAccent: "програм\u00ADмирование, кибер\u00ADбезопас\u00ADность и AI",
    subtitle: "Global IT Academy — академия кибербезопасности и программирования",
    description:
      "Обучение современным IT-технологиям для допризывной молодёжи и всех начинающих: очно и онлайн, в группе или индивидуально.",
    ctaRegister: "Записаться",
    ctaAdvisor: "AI-консультант",
    chips: ["Очно и онлайн", "Группа или индивидуально", "Сертификат с онлайн-проверкой", "Поддержка в трудоустройстве"],
    admission: "ПОСТУПЛЕНИЕ",
    admissionHint: "Количество мест ограничено",
    featuredLabel: "ТОП 2026",
    featuredTitle: "Применение AI шаг за шагом",
    featuredMeta: "3 дня × 2 часа · очно · группа",
    featuredPrice: "45 000 драм",
    directions: "направлений",
    directionsHint: "Web, AI, Cyber, Kids, QA",
    marqueeLabel: "Технологии, которым мы учим",
    scrollHint: "Смотреть курсы",
  },
  countdown: { days: "Дн", hours: "Час", minutes: "Мин", seconds: "Сек" },
  courses: {
    kicker: "Направления обучения",
    title: "ТОП курсы",
    copy: "Выберите специальность и начните IT-карьеру вместе с нами.",
    all: "Все курсы",
    details: "Подробнее",
    badges: { top2026: "ТОП 2026", top: "ТОП", new: "НОВОЕ" },
    items: {
      aiTeacher: { title: "Применение AI", subtitle: "шаг за шагом (3 дня)" },
      cyber: { title: "Кибербезопасность", subtitle: "Защищайте цифровой мир" },
      web: { title: "Web-программирование", subtitle: "Frontend и Backend технологии" },
      ai: { title: "Искусственный интеллект", subtitle: "AI-инструменты и машинное обучение" },
      kids: { title: "Программирование для детей", subtitle: "Логика, игры и творческое мышление" },
      qa: { title: "QA Testing", subtitle: "Ручное и автоматизированное тестирование" },
    },
  },
  faculties: {
    title: "Факультеты",
    copy: "Выберите интересующую область и начните профессиональное развитие",
    loading: "Загрузка...",
    error: "Ошибка при загрузке данных",
    soon: "Курсы появятся в ближайшее время",
    status: {
      new: "Новый",
      discount: "Скидка",
      action: "Акция",
      enrollment: "Набор",
      active: "Активный",
      draft: "Черновик",
      full: "Мест нет",
      completed: "Завершён",
    },
  },
  stories: { title: "Истории", add: "Добавить", empty: "Историй пока нет", createFirst: "Создайте первую историю" },
  news: {
    kicker: "Global IT Academy",
    title: "Новости",
    type: { event: "Мероприятие", announcement: "Объявление", news: "Новость" },
    details: "Подробнее",
    readFull: "Читать полностью",
    viewAll: "Все новости",
    months: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  },
  partners: {
    title: "Наши партнёры",
    copy: "Мы гордимся партнёрами, которые помогают нам давать качественное образование",
    visit: "Перейти",
  },
  whyUs: {
    kicker: "Почему Global IT Academy",
    title: "Обучение, построенное вокруг вашего результата",
    copy: "Современная программа, удобный формат и поддержка — от первого урока до работы.",
    items: [
      { title: "Формат на ваш выбор", text: "Очно в Ереване или онлайн, в группе или индивидуально — выбирайте то, что удобно вам." },
      { title: "AI-консультант по карьере", text: "Бесплатный AI-консультант за несколько минут поможет выбрать подходящее направление." },
      { title: "Проверяемый сертификат", text: "Сертификат по окончании можно проверить онлайн по контрольному номеру." },
      { title: "Удобная оплата", text: "Visa, Mastercard, Arca, Idram, подарочные карты и помощь с возвратом социальных расходов." },
      { title: "Карьера и партнёры", text: "Поддержка в трудоустройстве и сотрудничество с партнёрскими организациями." },
      { title: "Всегда под рукой", text: "Установите сайт как приложение и получайте уведомления о новых курсах и мероприятиях." },
    ],
  },
  faq: {
    kicker: "Частые вопросы",
    title: "То, о чём спрашивают чаще всего",
    copy: "Короткие ответы, чтобы решение далось легко.",
    items: [
      {
        q: "В каком формате проходят курсы?",
        a: "Очно (Ереван) и онлайн, в группе и индивидуально. Формат вы выбираете при записи.",
      },
      {
        q: "Какова продолжительность курсов?",
        a: "Базовый этап — 6 месяцев, допризывный — 9 месяцев, академический — 18 месяцев. Есть и краткие интенсивы, например трёхдневный тренинг по применению AI.",
      },
      {
        q: "Как записаться?",
        a: "Нажмите «Записаться», заполните заявку, и мы свяжемся с вами. Также можно написать в Telegram или позвонить по номеру +374 98 960959.",
      },
      {
        q: "Выдаётся ли сертификат?",
        a: "Да, по окончании выдаётся сертификат, подлинность которого можно проверить на странице «Проверка подлинности сертификатов» по контрольному номеру.",
      },
      {
        q: "Как можно оплатить?",
        a: "Картами Visa, Mastercard, Arca и через Idram. Доступны также подарочные карты.",
      },
      {
        q: "Какое направление выбрать, если я ещё не решил?",
        a: "Воспользуйтесь бесплатным AI-консультантом на главной странице: после нескольких вопросов он предложит подходящее направление.",
      },
    ],
  },
  contact: {
    title: "Готовы начать свой путь в IT?",
    copy: "Поторопитесь с записью: до окончания набора осталось несколько дней, а количество мест ограничено.",
    telegram: "Telegram",
    telegramText: "Напишите нам в Telegram",
    phone: "Телефон",
    phoneText: "Позвоните нам",
    social: "Социальные сети",
    socialText: "Подписывайтесь",
    app: {
      title: "Веб-приложение",
      text: "Наш сайт можно установить на телефон как веб-приложение — без App Store и Google Play",
      f1: "Быстрый доступ с домашнего экрана",
      f2: "Как нативное приложение",
      f3: "Автоматические обновления",
      install: "Установить приложение",
      iosAlert: "Откройте сайт в Safari, нажмите кнопку «Поделиться» и выберите \"Add to Home Screen\"",
      androidAlert: "Откройте сайт в Chrome, нажмите меню (⋮) и выберите \"Install app\" или \"Add to Home screen\"",
      installShort: "Установить",
      webInstruction: "Откройте сайт в Chrome и нажмите значок «Установить» в адресной строке",
    },
  },
  contactPage: {
    kicker: "Связь",
    title: "Свяжитесь с нами",
    subtitle: "Вопросы, консультация или запись — выберите удобный способ связи, и мы ответим как можно скорее.",
    phone: "Телефон",
    phoneAction: "Позвонить",
    telegramAction: "Написать в Telegram",
    whatsappAction: "Написать в WhatsApp",
    viberAction: "Написать в Viber",
    youtubeAction: "Подписаться",
    linkedinAction: "Подписаться",
    formTitle: "Запишитесь на курс",
    formText: "Оставьте заявку, и наша команда свяжется с вами.",
    register: "Подать заявку",
  },
  newsletter: {
    title: "Следите за новостями",
    text: "Первыми узнавайте о новых курсах и мероприятиях",
    placeholder: "Ваш e-mail",
    subscribe: "Подписаться",
    subscribing: "Отправка...",
    errorTitle: "Ошибка",
    invalid: "Введите корректный адрес электронной почты",
    alreadyTitle: "Уже подписаны",
    alreadyText: "Этот e-mail уже подписан на наши новости",
    successTitle: "Готово!",
    resubscribed: "Вы снова подписаны на наши новости",
    subscribed: "Вы успешно подписались на наши новости",
    genericError: "При подписке произошла ошибка",
  },
  footer: {
    rights: "© 2026 Global IT Academy. Все права защищены.",
    tagline: "Курсы программирования, кибербезопасности и AI в Армении",
    partnership: "Сотрудничество",
    giftCards: "Подарочные карты",
    certificate: "Проверка подлинности сертификатов",
    socialRefund: "Заявление на возврат социальных расходов",
    privacy: "Политика конфиденциальности",
    refund: "Политика возврата и отмены",
    navTitle: "Сайт",
    coursesTitle: "Курсы",
    legalTitle: "Полезное",
  },
  seo: {
    homeTitle: "Global IT Academy — IT-курсы в Армении",
    homeDescription:
      "Профессиональные курсы программирования, кибербезопасности и AI в Армении — очно и онлайн. Web, Python, Java, C#, C++, QA. Записывайтесь в Global IT Academy.",
  },
  newsSection: {
    title: "Новости",
    description: "Последние новости, мероприятия и объявления Global IT Academy",
    empty: "Пока новостей нет",
    details: "Подробнее",
    openLink: "Открыть ссылку",
    typeEvent: "Мероприятие",
    typeAnnouncement: "Объявление",
    typeNews: "Новость",
  },
  newsDetail: {
    home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
    featured: "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
    register: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435",
    registerShort: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F",
    eventDetails: "\u0414\u0435\u0442\u0430\u043B\u0438 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
    dateTime: "\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
    location: "\u041C\u0435\u0441\u0442\u043E",
    map: "\u041A\u0430\u0440\u0442\u0430",
    deadline: "\u041A\u0440\u0430\u0439\u043D\u0438\u0439 \u0441\u0440\u043E\u043A \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
    urgent: "\u0421\u0440\u043E\u0447\u043D\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435",
    validUntil: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043E:",
    description: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    showLess: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435",
    readMore: "\u0427\u0438\u0442\u0430\u0442\u044C \u0434\u0430\u043B\u0435\u0435",
    speakers: "\u0421\u043F\u0438\u043A\u0435\u0440\u044B",
    agenda: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430",
    speakersLabel: "\u0421\u043F\u0438\u043A\u0435\u0440(\u044B):",
    externalLink: "\u0427\u0438\u0442\u0430\u0442\u044C \u0434\u0430\u043B\u0435\u0435",
    notFound: "\u041D\u043E\u0432\u043E\u0441\u0442\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430",
    videoError: "\u0412\u0438\u0434\u0435\u043E \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.",
    home2: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
    newsCrumb: "\u041D\u043E\u0432\u043E\u0441\u0442\u0438",
  },
  admissionSection: {
    loading: "Загрузка...",
    title: "Приём",
    subtitle: "Качественное IT-образование с современными технологиями и опытными специалистами",
    datesTitle: "Важные даты",
    deadlineLabel: "Заявки принимаются до",
    startLabel: "Начало курса",
    durationTitle: "Длительность курса",
    month: "месяцев",
    durationBase: "базовый",
    durationPre: "допризывный",
    durationAcademic: "академический",
    monthLessons: "1 месяц = 12 занятий",
    scheduleTitle: "Дни недели и часы",
    daysOdd: "Пн. Ср. Пт.",
    daysEven: "Вт. Чт. Сб.",
    dependsOnGroup: "(Зависит от группы)",
    priceTitle: "Стоимость",
    group: "Групповое",
    individual: "Индивидуальное",
    monthly: "в месяц",
    currency: "драм",
    formatsTitle: "Форматы обучения",
    inPerson: "Очно",
    online: "Онлайн",
    timetableTitle: "Расписание",
    weekly: "В неделю",
    weeklyValue: "3 раза",
    lessonLength: "Длительность занятий",
    lessonLengthValue: "1.5 - 2 часа",
    ageGroup: "Возрастная группа",
    ageGroupValue: "от 15 лет",
    bonusesTitle: "Бонусы и преимущества",
    bonus1: "1 месяц бесплатной практики",
    bonus2: "Выпускной сертификат на трёх языках",
    bonus3: "Аккредитовано Министерством образования, науки, культуры и спорта РА",
    bonus4: "Возможность возврата до 100 000 драмов расходов на обучение.",
  },
  servicesSection: {
    title: "Наши услуги",
    subtitle: "Мы предлагаем широкий спектр услуг для цифровизации вашего бизнеса",
    learnMore: "Узнать больше",
    order: "Заказать",
  },
};
